import { logout } from '@/api/mutations/auth/request';
import type { PopoverLinkProps, SidebarLinkProps } from '@/components/atoms';
import { routes } from './routes';

export const sidebarContent: SidebarLinkProps[] = [
  { icon: 'LayoutDashboard', text: 'Dashboard', pathname: routes.root },
  {
    icon: 'ShieldCheck',
    text: 'KYB Verification',
    pathname: routes.kyb,
    tourId: 'nav-kyb',
  },
  { icon: 'Store', text: 'Store', pathname: routes.store, tourId: 'nav-store' },
  {
    icon: 'Tag',
    text: 'Products',
    pathname: routes.products,
    tourId: 'nav-products',
  },
  {
    icon: 'Layers',
    text: 'Orders',
    pathname: routes.sales,
    tourId: 'nav-orders',
  },
  {
    icon: 'MessagesSquare',
    text: 'Conversations',
    pathname: routes.conversations,
    tourId: 'nav-conversations',
  },
  {
    icon: 'Truck',
    text: 'Shipping',
    pathname: routes.shipping,
    tourId: 'nav-shipping',
  },
  {
    icon: 'CreditCard',
    text: 'Transactions',
    pathname: routes.transactions,
    tourId: 'nav-transactions',
  },
  { icon: 'Activity', text: 'Analytics', pathname: routes.analytics },
  {
    icon: 'Receipt',
    text: 'Billing',
    pathname: `${routes.settings}?tab=subscription`,
    tourId: 'nav-billing',
  },
  {
    icon: 'Gift',
    text: 'Refer & Earn',
    pathname: routes.referAndEarn,
  },
];

export const sidebarFooter: SidebarLinkProps[] = [
  {
    icon: 'Settings',
    text: 'Account Settings',
    pathname: routes.settings,
    tourId: 'nav-settings',
  },
  {
    icon: 'BadgeQuestionMark',
    text: 'Help & Support',
    pathname: routes.support,
  },
];

const handleLogout = () => {
  void logout().finally(() => {
    window.location.href = routes.login;
  });
};

export const profilePopoverLinks: PopoverLinkProps[] = [
  { to: routes.settings, label: 'Profile', icon: 'UserRound' },
  { to: '#', label: 'Logout', icon: 'LogOut', onClick: handleLogout },
];
